import React, { createContext, useContext, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";
import WizardStore from "../store/wizardstore";
import { observer } from "mobx-react-lite";
import formatNumber from "accounting-js/lib/formatNumber";
import moment from "moment";
const wizardStoreCtx = createContext(WizardStore);
export const ReviewConsumption = observer(() => {
  const wizardStore = useContext(wizardStoreCtx);
  const materialGrid = useRef(null);
  const formatDigitOil = (params) => {
    const { value } = params;
    // this puts commas into the number eg 1000 goes to 1,000,
    // i pulled this from stack overflow, i have no idea how it works
    if (value) {
      return formatNumber(value, {
        precision: 2,
        thousand: ",",
      });
    }
  };
  const gridcolumnDefs = {
    columnDefs: [
      {
        headerName: "#",
        valueGetter: "node.rowIndex + 1",
        width: 50,
        resizable: true,
        sortable: true,
      },

      {
        headerName: "Chemical",
        field: "chemicals",
        width: 180,
        resizable: true,
        sortable: true,
      },
      {
        headerName: "Units",
        field: "units",
        width: 80,
        resizable: true,
        sortable: true,
      },
      {
        headerName: "Previous Stock",
        field: "openingStock",
        width: 100,
        resizable: true,
        sortable: true,
        cellStyle: {
          textAlign: "right",
        },
        editable: false,
        type: "numberColumn",
        valueFormatter: formatDigitOil,
      },
      {
        headerName: "Usage",
        field: "usage",
        width: 100,
        resizable: true,
        sortable: true,
        cellStyle: {
          textAlign: "right",
          backgroundColor: "rgb(204,218,236)",
        },
        editable: false,
        type: "numberColumn",
        valueFormatter: formatDigitOil,
      },
    ],
  };

  return (
    <div className="ms-Grid" dir="ltr">
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <SubPageHeaderTitle
            title={`Review Material Consumptions on ${moment(
              wizardStore.productionDate
            ).format("dddd MMMM Do YYYY")}`}
          />
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <div
            className="ag-theme-balham"
            style={{
              minHeight: "70vh",
              height: "70vh",
              width: "100%",
              paddingTop: "20px",
            }}
          >
            <AgGridReact
              rowData={[...wizardStore.importConsumptions.values()]}
              ref={materialGrid}
              gridOptions={{
                defaultColDef: {
                  sortable: true,
                  filter: true,
                  enableValue: true,
                },

                rowSelection: "single",
                pagination: true,
                columnDefs: gridcolumnDefs.columnDefs,
                animateRows: true,
              }}
              rowSelection="single"
              copyHeadersToClipboard={true}
              overlayLoadingTemplate={`${(
                <span class="ag-overlay-loading-center">
                  Please wait while your rows are loading
                </span>
              )}`}
              overlayNoRowsTemplate={
                '<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;">No Result</span>'
              }
            ></AgGridReact>
          </div>
        </div>
      </div>
    </div>
  );
});

